/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {Serializable} from '../../engine/db/serializable';

/**
 * Represent a set of saved results in IndexedDB for a given search-input
 */
export class HistoryInput implements Serializable {
  /**
   * Id is the indexedDbKey input passed to te search-input
   */
  public id: string;

  /**
   * Saved results of the search-input
   */
  public lastResults: any[] = [];

  // Members of Serializable
  public setId(id: any) {
    this.id = id;
  }

  public serialize(): any {
    return this;
  }
}
